import React, { useEffect, useState } from 'react';
import { Button, ConfigProvider, Dropdown, Layout } from "antd";
import { MenuOutlined, PlusOutlined } from "@ant-design/icons";
import SidebarMenu from "./components/Menu";
import { useMainLayoutContext } from "../index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { onChangeVisibleDrawer, onChangeVisibleModal } from "../../redux/actions/layout/interaction/action";
import { t } from "i18next";
import { AbilityUtil } from "../../custom/permission/Can";
import { ActionKeys } from "../../custom/permission/Ability";
import { BASE_PATH } from "../../custom/axios/config/Url";
import { ViewVersion } from "@dogoo/dogoo-version";

const { Sider } = Layout

function LayoutSidebar() {

    const [collapsed, setCollapsed] = useState(false);
    const [action, setAction] = useState(null)

    const { siderData } = useMainLayoutContext()
    const { pathname } = useLocation()

    const dispatch = useDispatch()

    function initState() {
        dispatch(onChangeVisibleDrawer(null))
    }

    useEffect(() => {
        initState()
    }, [])

    useEffect(() => {

        const debounce = setTimeout(() => {

            const currentAction = siderData?.find(item => pathname?.includes(item.key))?.action

            switch (currentAction?.key) {
                default:
                    if (currentAction?.type === "buttons") {
                        const cloneAction = currentAction.children?.find(item => item.key?.includes(pathname?.split("/").slice(0, 5).join("/")))
                        setAction(cloneAction)
                        return
                    }
                    setAction(currentAction)
            }
        }, 200)

        return () => {
            clearTimeout(debounce)
        }
    }, [pathname, siderData])

    return (
        <Sider
            width={280}
            collapsible
            trigger={null}
            collapsed={collapsed}
            style={{
                background: "var(--primary-bg)",
                fontSize: "var(--primary-text)"
            }}
        >
            <div
                className={`sidebar__heading flex items-center ${collapsed ? "justify-center" : ""} px-[19px]`}
                style={{ height: "var(--header-height)" }}
            >
                <MenuOutlined
                    className={"text-[22px] font-bold text-[var(--primary-text-color)]"}
                    onClick={() => setCollapsed(prev => !prev)}
                />
                {!collapsed &&
                    <Link to={"/hrm/timekeeping/time-sheet/timesheet"} className={"text-black"}>
                        <div className={`sidebar__logo flex items-center px-[15px]  transition ease-in-out delay-150`}>
                            <img
                                src={`${BASE_PATH}/static-medias/logo/doTnp.png`}
                                alt="doTNP"
                                className={"rounded-[var(--secondary-radius)] w-[30px] h-[30px]"}
                            />
                            <h2 className={"px-[10px] text-[var(--primary-text-color)] text-[18px]"}>
                                doTNP
                            </h2>
                        </div>
                    </Link>
                }
            </div>

            <div className={"w-full flex items-center justify-center py-[16px]"}>
                <>
                    {action?.type === "button" && (
                        <ActionButton
                            actionKey={action?.key}
                            buttonType={action?.buttonType}
                            collapsed={collapsed}
                            subjectName={action?.subjectName}
                            label={action?.label}
                        />
                    )}

                    {action?.type === "dropdown" && (
                        <ActionDropdownButton
                            actionKey={action.key}
                            collapsed={collapsed}
                            menuData={action.children}
                            subjectName={action.subjectName}
                            label={action.label}
                        />
                    )}

                    {!action && (
                        <div className={"h-[40px]"} />
                    )}
                </>
            </div>

            <div style={{ marginLeft: "-9px" }}>
                <SidebarMenu />

                <ViewVersion
                    bottom={0}
                    left={10}
                    style={{
                        fontSize: '13px',
                        zIndex: 10000
                    }}
                />
            </div>
        </Sider>
    );
}

export default LayoutSidebar;

const ActionButton = ({
    label = t("common.add"),
    collapsed,
    buttonType,
    actionKey,
    subjectName
}) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    function onClick() {

        switch (buttonType) {
            case "drawer":
                dispatch(onChangeVisibleDrawer(actionKey))
                break
            case "modal":
                dispatch(onChangeVisibleModal(actionKey))
                break
            default:
                navigate(actionKey)

        }
    }

    return <ConfigProvider
        theme={{
            token: {
                motion: false
            }
        }
        }>
        <Button
            type="primary"
            icon={<PlusOutlined className={"text-[15px] ml-[5px] mr-[5px]"} />}
            shape={!collapsed ? "default" : "circle"}
            onClick={onClick}
            disabled={!AbilityUtil.allow(actionKey?.includes("/setting/") ? ActionKeys.SETTING : ActionKeys.CREATE, subjectName, {})}
            className={"custom-btn flex items-center justify-center rounded-[var(--primary-radius)]"}
        >
            {!collapsed && <p className={"mr-[3px] font-[600] leading-[20px]"}>
                {label || t("common.add")}
            </p>}
        </Button>
    </ConfigProvider>
}

const ActionDropdownButton = ({
    actionKey,
    collapsed,
    menuData,
    label = t("common.add"),
    subjectName
}) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { pathname } = useLocation()

    function onClickDropdown({ key, item }) {
        switch (item?.props?.buttonType) {
            case "drawer":
                navigate(item?.props?.redirect)
                dispatch(onChangeVisibleDrawer(key))
                break
            case "modal":
                navigate(item?.props?.redirect)
                dispatch(onChangeVisibleModal(key))
                break
            default:
                navigate(key)

        }
    }

    return <ConfigProvider
        theme={{
            token: {
                motion: false
            }
        }}
    > <Dropdown
        menu={{
            items: menuData,
            onClick: onClickDropdown,
            selectedKeys: pathname,
            className: "extraMenuFilter",
            trigger: ["click"]
        }}
        disabled={!AbilityUtil.allow(actionKey?.includes("/setting/") ? ActionKeys.SETTING : ActionKeys.CREATE, subjectName, {})}
    >

            <Button
                type="primary"
                icon={<PlusOutlined className={"text-[15px] ml-[5px] mr-[5px]"} />}
                shape={!collapsed ? "default" : "circle"}
                disabled={!AbilityUtil.allow(actionKey?.includes("/setting/") ? ActionKeys.SETTING : ActionKeys.CREATE, subjectName, {})}
                className={"custom-btn flex items-center justify-center rounded-[var(--primary-radius)]"}
            >
                {!collapsed ? <p className={"ml-[6px] mr-[3px] font-[600] leading-[20px]"}>
                    {label}
                </p> : ""}
            </Button>
        </Dropdown>
    </ConfigProvider >

}